import { LocationInterface, LocationResource } from 'util/resources/Location';

export const formattedAddress = (location: LocationResource | LocationInterface) => {
  if (!location) {
    return null;
  }
  return [
    location.address,
    location.neighborhood,
    location.administrativeAreaLevel2,
    location.administrativeAreaLevel1,
  ]
    .filter(Boolean)
    .join(', ');
};

export const shortAddress = (location: LocationResource) => {
  if (!location) {
    return null;
  }
  return [location.address, location.neighborhood].filter(Boolean).join(', ');
};
